import { ComponentProps, FC } from 'react'
import { Button, DialogTitle, ModalCenter, useAnalytic } from 'src/components'
import { ETrackingEvent } from 'src/enums'
import { ArchiveCampaignIll } from 'src/images'

interface IProps extends ComponentProps<typeof ModalCenter> {
  onArchive?: () => void
}

export const ConfirmArchiveCampaignPopup: FC<IProps> = ({ onArchive, ...props }) => {
  const { eventHandler } = useAnalytic('my_jobs')

  return (
    <ModalCenter
      {...props}
      contentStyles={{ width: 424 }}
    >
      <div className="fx-column fx-center gap-8 txt-center">
        <div className="fx-column gap-2">
          <DialogTitle className="py-3">Archive Job?</DialogTitle>
          <div className="fx-column gap-2">
            <div className="fs-14 fw-700 lh-20 txt-negative-600">
              This action CANNOT be undone.
            </div>
            <div className="body-14 txt-black-02" style={{ maxWidth: 324 }}>
              This job listing will be closed, meaning no new applicants can apply.
              The job link will no longer be active or shown in the KNOWME Job
              Marketplace.
            </div>
          </div>
        </div>
        <img src={ArchiveCampaignIll} alt="archive-campaign" width={120} height={120}/>
        <div className="body-14 txt-black-02">
          You can view the archived listing in the <br/>My Jobs “Archived” tab.
        </div>
        <div className="fx-column gap-3 w-100-p">
          <Button
            className="py-3"
            onClick={eventHandler(ETrackingEvent.BTN_CONFIRM_ARCHIVE_JOB, () => {
              onArchive?.()
              props.onClose?.()
            })}
          >
            Archive Job
          </Button>
          <Button
            variant="secondary"
            className="py-3"
            onClick={eventHandler(ETrackingEvent.BTN_CANCEL_ARCHIVE_JOB, () => props.onClose?.())}
          >
            Cancel
          </Button>
        </div>
      </div>
    </ModalCenter>
  )
}
